import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import {
    deleteFilterValueUser,
    getFilterValue,
    getFilterValueApps,
    getFilterValueUsers,
    resetDagState,
    setFilterValueUser,
} from 'redux/actions/dagActions';
import { getUsers } from 'redux/actions/usersActions';
import { logoutUser } from 'redux/actions/authActions';
import { Theme } from 'utils/Theme';
import Header from 'components/layout/Partials/Header';
import { Link, NavLink, withRouter } from 'react-router-dom';
import AccessDenied from 'components/common/AccessDenied';
import Loading from 'components/common/Loading';
import * as Icon from 'react-feather';
import Select from 'react-select';
import isEmpty from 'utils/is-empty';
import AdminLayout from 'components/layout/AdminLayout';
import DataTable from 'react-data-table-component';
import { dagResync } from 'components/common/Notfications';
import { ToastsStore } from 'react-toasts';
import { userColumns, dynamicAppsColumns } from './Partials/constants';

const styles = Theme();

class FilterValue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dagLoading: true,
            filterValue: null,
            filterValueUsers: null,
            filterValueApps: {},
            options: [],
            loading: true,
            users: {},
            selectedUser: null,
            errors: {},
            userToDelete: null,
            appToDelete: null,
        };
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.getFilterValue(id);
        this.props.getFilterValueUsers(id);
        this.props.getFilterValueApps(id);
        this.props.getUsers();
    }

    componentWillUnmount() {
        this.props.resetDagState();
    }

    confirmUserDelete = () => {
        this.props.deleteFilterValueUser(
            this.state.userToDelete,
            this.state.filterValue._id
        );

        this.setState({ userToDelete: null });
    };

    handleChange = (selectedUser) => {
        this.setState({ selectedUser });
    };

    addUserToFilterValue = () => {
        if (this.state.selectedUser !== null) {
            const user = this.state.selectedUser.value;

            const filterValue = this.state.filterValue._id;
            const filter = this.state.filterValue.filter._id;

            this.props.setFilterValueUser({ user, filterValue, filter });
            this.setState({ selectedUser: null });
        } else {
            ToastsStore.warning('Please select a user to add');
        }
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        let {
            dagLoading,
            users,
            options,
            filterValue,
            filterValueUsers,
            filterValueApps,
        } = prevState;

        if (nextProps.users && nextProps.dag) {
            if (
                nextProps.users.loading === false &&
                nextProps.users.users !== null
            ) {
                options = [];
                nextProps.users.users.map((user) => {
                    return options.push({
                        value: user._id,
                        label: `${user.name} -  ${user.email}`,
                    });
                });
            }

            if (nextProps.dag.filterValue) {
                filterValue = nextProps.dag.filterValue;
            }
            if (nextProps.dag.filterValueUsers) {
                filterValueUsers = [];
                nextProps.dag.filterValueUsers.map((value) => {
                    return filterValueUsers.push(value.user);
                });
                // filterValueUsers = nextProps.dag.filterValueUsers;
            }

            if (nextProps.dag.filterValueDynamicApps) {
                filterValueApps = nextProps.dag.filterValueDynamicApps;
            }

            dagLoading = nextProps.dagLoading;
        }

        return {
            dagLoading,
            users,
            options,
            filterValue,
            filterValueUsers,
            filterValueApps,
        };
    }

    render() {
        const { classes, auth, history } = this.props;
        const {
            selectedUser,
            dagLoading,
            options,
            filterValue,
            filterValueUsers,
            filterValueApps,
            userToDelete,
        } = this.state;

        return (
            <AdminLayout>
                <div className="o-page">
                    <Header>
                        <h2 className="c-navbar__title">
                            {' '}
                            {filterValue
                                ? `${filterValue.filter.title} > ${filterValue.title}`
                                : ''}{' '}
                        </h2>
                    </Header>
                    {
                        !auth.isAuthenticated && auth.user.role !== 'Admin' ? (
                            <AccessDenied props={{ classes, history }} />
                        ) : dagLoading === true ||
                          filterValue === null ||
                          filterValue === undefined ||
                          isEmpty(filterValue) === true ? (
                            <div className="u-p-zero u-m-zero">
                                <Loading />
                            </div>
                        ) : (
                            <div className="u-m-xsmall">
                                <div className={'row'}>
                                    {dagResync(classes)}
                                    <div className="col-md-12 col-sm-12 col-xl-12 u-mb-medium">
                                        <div className="u-m-auto">
                                            <div className="c-card u-p-zero u-m-zero">
                                                <div className="o-line c-card__title u-p-small u-m-small">
                                                    <h4
                                                        className={`c-card__title ${classes.colorSecondary}`}
                                                    >
                                                        {filterValue.title}
                                                    </h4>
                                                    <div className="c-dropdown dropdown">
                                                        <div
                                                            className={`c-btn ${classes.buttonPrimary} has-icon dropdown-toggle`}
                                                            id="MoreActionsDropdown"
                                                            data-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            More Actions
                                                        </div>

                                                        <div
                                                            className="c-dropdown__menu dropdown-menu has-arrow dropdown-menu-right"
                                                            aria-labelledby="MoreActionsDropdown"
                                                        >
                                                            <div
                                                                onClick={() => {
                                                                    history.goBack();
                                                                }}
                                                                className="c-dropdown__item dropdown-item"
                                                            >
                                                                Back
                                                            </div>
                                                            <Link
                                                                to={`/settings/dag/filter-values/${filterValue.filter._id}/create`}
                                                                className="c-dropdown__item dropdown-item"
                                                            >
                                                                New{' '}
                                                                {
                                                                    filterValue
                                                                        .filter
                                                                        .title
                                                                }
                                                            </Link>
                                                            <Link
                                                                to={`/settings/dag/filters`}
                                                                className="c-dropdown__item dropdown-item"
                                                            >
                                                                Filters
                                                            </Link>
                                                            <Link
                                                                to={`/settings/dag/dynamic-apps`}
                                                                className="c-dropdown__item dropdown-item"
                                                            >
                                                                Dynamic Apps
                                                            </Link>
                                                            <Link
                                                                to={`/settings/dag/master-apps`}
                                                                className="c-dropdown__item dropdown-item"
                                                            >
                                                                Master Apps
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="u-m-small u-p-small">
                                                    <h5
                                                        className={
                                                            'u-text-muted u-pb-small'
                                                        }
                                                    >
                                                        Users for{' '}
                                                        {filterValue.filter
                                                            .title || ''}{' '}
                                                        {filterValue.title ||
                                                            ''}
                                                    </h5>

                                                    <div className={'row'}>
                                                        <div
                                                            className={
                                                                'col-xs-12 col-sm-8'
                                                            }
                                                        >
                                                            <Select
                                                                className={
                                                                    'u-mb-small'
                                                                }
                                                                value={
                                                                    selectedUser
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                                options={
                                                                    options
                                                                }
                                                            />
                                                        </div>
                                                        <div
                                                            className={
                                                                'col-xs-12 col-sm-4'
                                                            }
                                                        >
                                                            <button
                                                                onClick={
                                                                    this
                                                                        .addUserToFilterValue
                                                                }
                                                                className={`c-btn c-btn--medium c-btn--fullwidth ${classes.buttonPrimary}`}
                                                            >
                                                                {' '}
                                                                Add User
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    {filterValueUsers ===
                                                        null ||
                                                    filterValueUsers ===
                                                        undefined ? (
                                                        ''
                                                    ) : filterValueUsers.length >
                                                      0 ? (
                                                        <div className={'row'}>
                                                            <div className="col-sm-12 c-table-responsive@wide">
                                                                {userToDelete ===
                                                                null ? (
                                                                    <DataTable
                                                                        noHeader={
                                                                            true
                                                                        }
                                                                        className={
                                                                            'c-table'
                                                                        }
                                                                        pagination
                                                                        columns={userColumns(
                                                                            (
                                                                                id
                                                                            ) =>
                                                                                this.setState(
                                                                                    {
                                                                                        userToDelete: id,
                                                                                    }
                                                                                )
                                                                        )}
                                                                        data={
                                                                            filterValueUsers
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <table className="c-table">
                                                                        <tbody>
                                                                            <tr className="c-table__row">
                                                                                <td
                                                                                    className="c-table__cell"
                                                                                    colSpan={
                                                                                        4
                                                                                    }
                                                                                >
                                                                                    Deleting
                                                                                    User
                                                                                    will
                                                                                    remove
                                                                                    the
                                                                                    users
                                                                                    access
                                                                                    to
                                                                                    dynamic
                                                                                    applications.
                                                                                </td>
                                                                                <td className="c-table__cell u-text-right">
                                                                                    <button
                                                                                        onClick={() =>
                                                                                            this.setState(
                                                                                                {
                                                                                                    userToDelete: null,
                                                                                                }
                                                                                            )
                                                                                        }
                                                                                        className={`c-btn ${classes.buttonSecondary} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                                                                    >
                                                                                        <Icon.X
                                                                                            size={
                                                                                                10
                                                                                            }
                                                                                        />{' '}
                                                                                        Cancel
                                                                                    </button>

                                                                                    <button
                                                                                        onClick={
                                                                                            this
                                                                                                .confirmUserDelete
                                                                                        }
                                                                                        className={`c-btn ${classes.buttonDanger} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                                                                    >
                                                                                        <Icon.Slash
                                                                                            size={
                                                                                                10
                                                                                            }
                                                                                        />{' '}
                                                                                        Confirm
                                                                                        Delete
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                            </div>

                                            <div className="c-card u-p-zero u-m-zero">
                                                <div className="o-line c-card__title u-p-small u-m-small">
                                                    <h4
                                                        className={`c-card__title ${classes.colorSecondary}`}
                                                    >
                                                        Dynamic Apps for{' '}
                                                        {filterValue.filter
                                                            .title || ''}{' '}
                                                        {filterValue.title ||
                                                            ''}
                                                    </h4>
                                                </div>
                                                {filterValueApps === null ||
                                                filterValueApps ===
                                                    undefined ? (
                                                    ''
                                                ) : filterValueApps.length >
                                                  0 ? (
                                                    <div className="c-table-responsive@tablet">
                                                        <DataTable
                                                            columns={
                                                                dynamicAppsColumns
                                                            }
                                                            data={
                                                                filterValueApps
                                                            }
                                                            className={
                                                                'c-table'
                                                            }
                                                            pagination
                                                            noHeader={true}
                                                        />
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        // </div>
                    }
                </div>
            </AdminLayout>
        );
    }
}

FilterValue.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    getFilterValue: PropTypes.func.isRequired,
    resetDagState: PropTypes.func,
    deleteFilterValueUser: PropTypes.func,
    getUsers: PropTypes.func.isRequired,
    getFilterValueUsers: PropTypes.func.isRequired,
    setFilterValueUser: PropTypes.func.isRequired,
    getFilterValueApps: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    classes: PropTypes.object,
    dag: PropTypes.object,
    dagLoading: PropTypes.bool,
    match: PropTypes.object,
    history: PropTypes.object,
    users: PropTypes.array,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    dag: state.dag,
    users: state.users,
});

export default connect(mapStateToProps, {
    logoutUser,
    getFilterValue,
    getUsers,
    deleteFilterValueUser,
    getFilterValueUsers,
    resetDagState,
    setFilterValueUser,
    getFilterValueApps,
})(withStyles(styles)(withRouter(FilterValue)));
